import type { BrandConfig, BrandId } from './brand-config';

// Placeholder themes: neutral tokens until the owner confirms brand colours and logos.

export const brands: Readonly<Record<BrandId, BrandConfig>> = {
  imex: {
    id: 'imex',
    productName: 'ImEX Online Estimating',
    shortName: 'ImEX Estimating',
    platformName: 'ImEX Online',
    defaultLocale: 'en-CA',
    supportedLocales: ['en-CA', 'fr-CA'],
    currency: 'CAD',
    theme: { colorPrimary: '#2f5677', borderRadius: 6 },
  },
  rome: {
    id: 'rome',
    productName: 'Rome Online Estimating',
    shortName: 'Rome Estimating',
    platformName: 'Rome Online',
    defaultLocale: 'en-US',
    supportedLocales: ['en-US', 'es-US'],
    currency: 'USD',
    theme: { colorPrimary: '#4a5568', borderRadius: 6 },
  },
};
